import { mutationOptions } from '@tanstack/react-query';
import { ValidatedAccountNumber } from 'merchant-api/types';
import { checkout } from '..';
import { AxiosError } from 'axios';

export interface RequestData {
  accountNumber: string;
  applicationId: string;
}

const validateBank = (data: RequestData) =>
  checkout.post<ValidatedAccountNumber>('/v1/bank-info/validate-bank-account', data)
    .then((res) => res.data);


export const validateBankOpts = () =>
  mutationOptions<ValidatedAccountNumber, AxiosError, RequestData>({
    mutationFn: validateBank
  });

